export var isEmpty=function(a){for(var b in a)return!1;return!0};
//# sourceMappingURL=isEmpty.js.map